import React, { useState, useEffect } from 'react'
import './index.scss'
import { ProgressBar } from 'primereact/progressbar'
import AllotmentList from './AllotmentList'
import { getAllotments, getAllotmentColorClass } from './allotmentUtils'
import LoadingIndicator from '../../LoadingIndicator'
import { useTranslation } from 'react-i18next'
import Messages from '../../../constants/Messages'
import { DASHBOARD_ALLOTMENT_VIEW_ENABLED } from '../../../configs/featureControlConfig'
import CommonRadioWithLabel from "../../../common/CommonRadioButton";
import LoadingAnimation from '../../LoadingAnimation/LoadingAnimation'

const AllotmentDetails = () => {
	const { t } = useTranslation(['labels', 'errors'])
	const ERROR = 'Error';
	const [allotmentValType, setAllotmentValType] = useState(
		'allotment-percentage'
	)
	const [isLoading, setIsLoading] = useState(false)

	const [allotmentList, setAllotmentList] = useState(
		/*listAllotmentsResponse ? listAllotmentsResponse.listallotments : */ null
	)
	const [allotment7Days, setAllotment7Days] = useState(0)
	const [allotment14Days, setAllotment14Days] = useState(0)

	//setEndIndex(rowCount - 1)

	useEffect(() => {
		;(async () => {
			try {
				const response = await getAllotments(14, setIsLoading)
				if (
					response &&
					response.listAllotments &&
					response.listAllotments.length
				) {
					setAllotmentList(response.listAllotments)
					if (
						response.totalAllotmentPercentWeight &&
						response.totalAllotmentPercentVolume &&
						response.totalAllotmentPercentVolume >
							response.totalAllotmentPercentWeight
					) {
						setAllotment14Days(response.totalAllotmentPercentVolume)
					} else {
						setAllotment14Days(
							response.totalAllotmentPercentWeight
								? response.totalAllotmentPercentWeight
								: response.totalAllotmentPercentVolume
								? response.totalAllotmentPercentVolume
								: 0
						)
					}
				} else if(!response){
					setAllotmentList(ERROR)
				}
			} catch (error) {
				console.log(error.message)
			}
		})()
	}, [])

	useEffect(() => {
		;(async () => {
			try {
				const response = await getAllotments(7, setIsLoading)
				if (response) {
					if (
						response.totalAllotmentPercentWeight &&
						response.totalAllotmentPercentVolume &&
						response.totalAllotmentPercentVolume >
							response.totalAllotmentPercentWeight
					) {
						setAllotment7Days(response.totalAllotmentPercentWeight)
					} else {
						setAllotment7Days(
							response.totalAllotmentPercentWeight
								? response.totalAllotmentPercentWeight
								: response.totalAllotmentPercentVolume
								? response.totalAllotmentPercentVolume
								: 0
						)
					}
				}
			} catch (error) {
				console.log(error.message)
			}
		})()
	}, [])

	const handleRadio = (e) => {
		setAllotmentValType(e.target.value)
	}
	
	return (
		<div className='allotment-details'>
			<div className='allotment-sub-heading'>
						{t('DASHBOARD.ALLMNT')}
					</div>
					{isLoading ? (
				<div className="loading-container">
					<LoadingAnimation />
				</div>
			) : allotmentList && allotmentList != ERROR && allotmentList.length > 0 ? (
				<>
				<div className='allotments-section '>
					<div className='allotment-stats-summary d-none d-lg-flex'>
						<div className='allotment-stats-summary-left'>
							<div className='left-block-metrics'>
								<div className='metrics-content'>
									<div className='progressbar-label'>
										{t('DASHBOARD.NEXT_S_DYS')}
									</div>
									<div className='progressbar-label-percent'>
										{allotment7Days}%
									</div>

								</div>

								<div className='progress-bar-allotment'>
									<ProgressBar
										value={allotment7Days}
										className={getAllotmentColorClass(allotment7Days)}
									></ProgressBar>
								</div>

							</div>
							<div className='left-block-metrics'>
								<div className='metrics-content'>
									<div className='progressbar-label'>
										{t('DASHBOARD.NEXT_F_DYS')}
									</div>
									<div className='progressbar-label-percent'>
										{allotment14Days}%
									</div>

								</div>
								<div className='progress-bar-allotment'>
									<ProgressBar
										value={allotment14Days}
										className={getAllotmentColorClass(allotment14Days)}
									></ProgressBar>
								</div>

							</div>

						</div>
						<div className='alloment-stats-type'>
							{/* <div className='form-item form-item--radio'>
								<input
									id='allotment-actual'
									type='radio'
									value='allotment-actual'
									name='allotment-value'
									className='form-item__field'
									aria-describedby='input-radio-description'
									onChange={handleRadio}
									checked={allotmentValType === 'allotment-actual' ? true : false} />
								<label
									for='allotment-actual'
									className='form-item__label'
								>
									{t('DASHBOARD.ACTUAL')}
								</label>
							</div> */}
							<CommonRadioWithLabel
								onChange={handleRadio}
								checked={allotmentValType === 'allotment-actual' ? true : false}
								value='allotment-actual'
								className={`radio-toggle-first`}
								label={t('DASHBOARD.ACTUAL')}
								name='allotment-value'
							/>
							{/* <div className='form-item form-item--radio'>
								<input
									id='allotment-percentage'
									type='radio'
									value='allotment-percentage'
									name='allotment-value'
									className='form-item__field'
									aria-describedby='input-radio-description '
									onChange={handleRadio}
									checked={allotmentValType === 'allotment-percentage'
										? true
										: false} />
								<label
									for='allotment-percentage'
									className='form-item__label'
								>
									{t('DASHBOARD.PRC')}
								</label>
							</div> */}
							<CommonRadioWithLabel
								checked={allotmentValType === 'allotment-percentage'
										? true
										: false}
								value='allotment-percentage'
								onChange={handleRadio}
								className={`radio-toggle-second `}
								label={t('DASHBOARD.PRC')}
								name='allotment-value'
							/>
						</div>


					</div>
					{DASHBOARD_ALLOTMENT_VIEW_ENABLED ? (
						// <div>
						<AllotmentList
							allotmentValType={allotmentValType}
							setIsLoading={setIsLoading}
							allotmentList={allotmentList} />
						// </div>
					) : (<></>)}

				</div>
				
				</>
				
			) : (
				<div className="no-allotment-details">
					{allotmentList !== ERROR
						? t(Messages.NO_ALLOTMENTS, { ns: 'errors' })
						: t(Messages.ALLOTMENTS_FAILED, { ns: 'errors' })}
				</div>
			)}
		</div>
	);
	
}

export default AllotmentDetails
